export const TIMEZONE_MESSAGE = 'Times and dates shown are based on UK timezone.';
export const COUNTRY_SELECT_LABEL = 'Choose delivery location';
export const DELIVERY_NOT_AVAILABLE_TO_COUNTRY_FIELD_ERROR =
  'Delivery not available to this country';
export const DELIVERY_NOT_AVAILABLE_TO_COUNTRY_MESSAGE =
  'Sorry, delivery is not available for this country. Please try a different delivery destination';
